import './notifications.css';
import { COMMON } from '../../constants';

/**
 * Adds a React component to show notification at the top right corner of the screen.
 *
 *  - Roles
 *     - Show a notification with title and color.
 *
 * @param type Defines if the given notification is a success or failure message.
 * @param msg Message to be shown in the notification.
 */

// export const Notification = (type, msg, visibleInitial = false) => {
export const Notification = (type, msg) => {
    if (type == COMMON.success || type == COMMON.error) {
        // Creating Notificaiton Item to show notification
        let notificationItem = document.createElement('div');
        notificationItem.setAttribute('id', 'notificationItem');
        notificationItem.setAttribute(
            'role',
            type == COMMON.success ? 'status' : 'alert'
        );
        notificationItem.setAttribute('data-testid', 'notification-item');
        notificationItem.classList.add(
            'notification-item',
            `${
                type == COMMON.success
                    ? 'notification-success'
                    : type == COMMON.error
                      ? 'notification-error'
                      : ''
            }`
        );
        notificationItem.innerHTML = `<span>${msg}</span>`;

        // Function to remove notification
        function removeNotification() {
            notificationItem.remove();
            let notificationWrapper = document.querySelector(
                '#notificationWrapper'
            );
            if (
                notificationWrapper &&
                notificationWrapper.children.length === 0
            ) {
                notificationWrapper.remove();
            }
        }

        // Element to remove notification by action button
        let closeNotification = document.createElement('button');
        closeNotification.className = 'close-btn';
        closeNotification.setAttribute('aria-label', 'close');
        closeNotification.setAttribute('data-testid', 'close-notification-btn');
        closeNotification.onclick = function () {
            removeNotification();
        };

        // Appending close notification button to notification item
        notificationItem.appendChild(closeNotification);

        // If notification wrapper is not created then create else just append notification item to notification wrapper
        let notificationWrapper = document.querySelector(
            '#notificationWrapper'
        );
        if (!notificationWrapper) {
            notificationWrapper = document.createElement('div');
            notificationWrapper.id = 'notificationWrapper';
            notificationWrapper.setAttribute(
                'data-testid',
                'notification-wrapper'
            );
            notificationWrapper.classList.add('notification-wrapper');
            document.body.appendChild(notificationWrapper);
        }
        notificationWrapper.appendChild(notificationItem);

        // Removing Notification from dom after 3s
        setTimeout(() => {
            removeNotification();
        }, 3000);
    }
};
